(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){

},{}],2:[function(require,module,exports){
// var $ = require('jquery');

// Avoid `console` errors in browsers that lack a console.
(function () {
	var method,
		noop = function () {
		},
		methods = ['assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error', 'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log', 'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd', 'timeStamp', 'trace', 'warn'],
		length = methods.length,
		console = (window.console = window.console || {});
	while (length--) {
		method = methods[length];
		// Only stub undefined methods.
		if (!console[method]) {
			console[method] = noop;
		}
	}
}());

$(document).ready(function () {
	var websiteName = 'Sander Janssen: ';

	// page transitions
	$('.wrapper-transition').animsition({
		inClass: 'fade-in-down-sm',
		outClass: 'fade-out-up-sm',
		inDuration: 750,
		outDuration: 750,
		linkElement: 'a:not([target="_blank"]):not([href^="#"]):not([href^="mailto:"]):not([href="javascript:void(0);"]):not([data-featherlight])',
		loading: true,
		loadingParentElement: 'body', //animsition wrapper element
		loadingClass: 'wrapper-transition-loading',
		loadingInner: '', // e.g '<img src="loading.svg" />'
		timeout: false,
		timeoutCountdown: 5000,
		onLoadEvent: true,
		browser: ['animation-duration', '-webkit-animation-duration'],
		// "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
		// The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
		overlay: false,
		overlayClass: 'animsition-overlay-slide',
		overlayParentElement: 'body',
		transition: function (url) {
			window.location.href = url;
		}
	});
	// page transitions => set header-link to 'aria-current'
	$('.wrapper-menuitems-desktop li:not(".link-social") a').on('click', function () {
		$('.wrapper-menuitems-desktop a').removeAttr('aria-current');
		$(this).attr('aria-current', true);
	});
	// page transitions => set
	$('.link-logo').on('click', function() {
		$('.wrapper-menuitems-desktop a').removeAttr('aria-current');
		$('.link-work a').attr('aria-current', true);
	});

	// portfolio filter, see https://github.com/patrickkunka/mixitup
	$('#work-overview').mixItUp({
		callbacks: {
			onMixStart: function(state, futureState) {
				console.log(websiteName + 'Sorting grid');
			},
			onMixBusy: function(state) {
				console.log(websiteName + 'Grid being sorted');
			},
			onMixEnd: function(state) {
				console.log(websiteName + 'Sorting grid complete');
			}
		},
		selectors: {
			target: '.global-grid-column',
			filter: '.button-filter',
			sort: '.sort-btn'
		},
		animation: {
			animateResizeContainer: true,
			duration: 750,
			easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
			effectsIn: 'scale fade stagger(500ms)',
			effectsOut: 'fade translateY(-100%) stagger(500ms)',
			perspectiveDistance: '2000px',
			queueLimit: 2,
			staggerSequence: function(i) {
				return (2*i) - (5*((i/3) - ((1/3) * (i%3))));
			}
		}
	});

	// pause video when we hover a slide
	$('#work-overview li').on('mouseover', function() {
		$('#work-overview').find('video').trigger('pause');
		$(this).find('video').trigger('play');
	});
	$('#work-overview li').on('mouseout', function() {
		$('#work-overview li').not(this).find('video').trigger('play');
	});

	// lightbox
	$('[data-featherlight]').featherlight({
		gallery: {
			next: 'next image »',
			previous: '« previous image',
			fadeIn: 300,
			fadeOut: 300
		},
		openSpeed: 300,
		closeSpeed: 300
	});
	// lightbox => pause all videos when lightbox is open
	$('[data-featherlight]').on('click', function() {
		console.log('⏸ all videos');
		setTimeout(function() {
			$(document).find('video').trigger('pause');
		}, 250);
	});
	// lightbox => play all videos when lightbox is closed
	$(document).bind("DOMNodeRemoved", function(e) {
		if(e.target.className === 'featherlight featherlight-iframe') {
			console.log('▶️ all videos');
			setTimeout(function() {
				$(document).find('video').trigger('play');
			}, 250);
		}
	});

	// hamburger menu
	var McButton = $(".ui-hamburgerbutton");
	var McBar1 = McButton.find('span:nth-child(1)');
	var McBar2 = McButton.find('span:nth-child(2)');
	var McBar3 = McButton.find('span:nth-child(3)');

	McButton.click(function () {
		$(this).toggleClass('is-open');
		$('.wrapper-menuitems-mobile, .wrapper-social-mobile').toggleClass('is-open');

		if (McButton.hasClass('is-open')) {
			McBar1.velocity({
				top: '50%'
			}, {
				duration: 200,
				easing: 'swing'
			});
			McBar3.velocity({
				top: '50%'
			}, {
				duration: 200, easing: 'swing'
			}).velocity({
				rotateZ: '90deg'
			}, {
				duration: 800,
				delay: 200,
				easing: [500, 20]
			});
			McButton.velocity({
					translateY: '-50%',
					rotateZ: '135deg'
				}, {
					duration: 800,
					delay: 200,
					easing: [500, 20]
				}
			);
		} else {
			McButton.velocity({
					translateY: '-50%',
					rotateZ: '0'
				}, {
					duration: 800,
					delay: 200,
					easing: [500, 20]
				}
			);
			McBar3.velocity({
				rotateZ: '0deg',
			}, {
				duration: 800,
				easing: [500, 20]
			}).velocity({
				top: '97%'
			}, {
				duration: 200,
				easing: 'swing'
			});
			McBar1.velocity('reverse', {
				delay: 800,
				easing: [500, 20]
			});
		}
	});

	// chameleon header
	$(document).on('scroll', function() {
		if ($(document).scrollTop() >= 50) {
			// user scrolled 50 pixels or more;
			// do stuff
			$('.global-header').addClass('is-fixed');
		} else {
			$('.global-header').removeClass('is-fixed');
		}
	});

	// switch light/dark-mode
	$('input[name="themeswitcher"]').on('change', function() {
		if ($(this).is(':checked')) {
			console.log(websiteName + 'Enabled dark-mode');
			$('body').removeClass('body-dark');
			$('body').addClass('body-light');
			$.cookie('sanderjanssen_theme', 'light', {
				expires: 365,
				path: '/',
				secure: true
			});
		} else {
			console.log(websiteName + 'Enabled light-mode');
			$('body').removeClass('body-light');
			$('body').addClass('body-dark');
			$.cookie('sanderjanssen_theme', 'dark', {
				expires: 365,
				path: '/',
				secure: true
			});
		}
	});

	// overall => disable any action on <a href="#">'s
	$('a[href="#"]').on('click', function(e) {
		e.preventDefault();
	});

	// overall => fancy scroll
	$('a[href^="#page"]').on('click', function(e) {
		var target = $( $(this).attr('href') );
		if ($(window).width() <= 719) {
			var extraScrollAmount = 80;
		} else {
			var extraScrollAmount = 100;
		}
		if( target.length ) {
			e.preventDefault();
			$('html, body').animate({
				scrollTop: target.offset().top - extraScrollAmount
			}, 750);
		}
	});

	// autogrow textarea
	(function($) {

		/*
		 * Auto-growing textareas; technique ripped from Facebook
		 */
		$.fn.autogrow  = function(options) {
			this.filter('textarea').each(function() {
				var $this       = $(this),
					minHeight   = $this.height(),
					lineHeight  = $this.css('lineHeight');
				var shadow = $('<div></div>').css({
					position:   'absolute',
					top:        -10000,
					left:       -10000,
					width:      $(this).width() - parseInt($this.css('paddingLeft')) - parseInt($this.css('paddingRight')),
					fontSize:   $this.css('fontSize'),
					fontFamily: $this.css('fontFamily'),
					lineHeight: $this.css('lineHeight'),
					resize:     'none'
				}).appendTo(document.body);
				var update  = function() {
					var times  = function(string, number) {
						for (var i = 0, r = ''; i < number; i ++) r += string;
						return r;
					};
					var val = this.value.replace(/</g, '&lt;')
						.replace(/>/g, '&gt;')
						.replace(/&/g, '&amp;')
						.replace(/\n$/, '<br/>&nbsp;')
						.replace(/\n/g, '<br/>')
						.replace(/ {2,}/g, function(space) { return times('&nbsp;', space.length -1) + ' ' });
					shadow.html(val);
					$(this).css('height', Math.max(shadow.height() + 32, minHeight));
				}
				$(this).change(update).keyup(update).keydown(update);
				update.apply(this);
			});
			return this;
		}
	})(jQuery);
	$('textarea').autogrow();

	$(function() {
		$('#mailform input, #mailform textarea').on('change', function() {
			var input = $(this);
			if (input.val().length) {
				input.addClass('populated');
			} else {
				input.removeClass('populated');
			}
		});

		setTimeout(function() {
			$('#fname').trigger('focus');
		}, 500);
	});

	$("#mailformSubmit").on('click', function(event) {
		console.log('Submitting mailform');

		//stop submit the form, we will post it manually.
		event.preventDefault();

		// Get form
		var form = $('#mailform')[0];

		// Create an FormData object
		var data = new FormData(form);

		// disabled the submit button
		$('#mailformSubmit').attr('disabled', true);

		$.ajax({
			type: 'POST',
			enctype: 'multipart/form-data',
			url: 'mailform.php',
			data: data,
			processData: false,
			contentType: false,
			cache: false,
			timeout: 2000,
			success: function(data) {
				console.log('SUCCESS: ', data);
				$('#mailform').addClass('has-notification');
				$('#mailformOutput').html(data);
				// $('#mailformSubmit').attr('disabled', true);
				$('#mailform')[0].reset();
				$('#mailform input, #mailform textarea').removeClass('populated');
				setTimeout(function() {
					$('#mailform').removeClass('has-notification');
					$('#mailformSubmit').attr('disabled', false);
				}, 10000);
			},
			error: function(e) {
				console.log('ERROR : ', e);
				$('#mailform').addClass('has-notification')
				$('#mailformOutput').html(e.responseText);
				$("#mailformSubmit").prop('disabled', false);
				setTimeout(function() {
					$('#mailform').removeClass('has-notification');
				}, 4500);
			}
		});
	});
});

},{}]},{},[1,2]);
